import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CustomerSearchResult } from 'src/app/core/models/customer-search-result';
import { Subject, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, last, mergeMap } from 'rxjs/operators';
import { SearchCustomerService } from 'src/app/core/services/search-customer.service';

import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import moment from 'moment';
import { PracticeModel } from 'src/app/core/models/practice.model';
import { SelectListItem } from 'src/app/core/models/select-list-item';
import { StandbyService } from '../standby/standby.service';
import { Location } from '@angular/common';
import { FindTimeModel } from 'src/app/core/models/find-time-model';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { ApiResponseCode } from 'src/app/core/enums';
import { Router } from '@angular/router';
import { FindTimeResultItem } from 'src/app/core/models/find-time-result-item-model';
import { Arguments } from 'src/app/core/models/arguments';
import { Utils } from 'src/app/core/utils';
import { SchedulerModel } from 'src/app/core/models/scheduler.model';
import { TerminologyItem } from 'src/app/core/interfaces/terminology-item';
import { ComplexBranch } from 'src/app/core/interfaces/complex-branch';
import { VisitReason } from 'src/app/core/interfaces/visit-reason';
import { SearchCustomerFilter } from 'src/app/core/interfaces/search-customer-filter';
import { TreatmentEntity } from 'src/app/core/interfaces/treatment-entity';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { ScopeService } from 'src/app/core/services/scope.service';
import { PriceListCode } from 'src/app/core/models/price-list-code';
import { SchedulerService } from '../scheduler/scheduler.service';
import { TreatmentModel } from 'src/app/core/models/treatment-model';
import { AppData } from 'src/app/app.data';
import { CustomerService } from 'src/app/core/services/customer.service';
import { timeCheckValidator } from 'src/app/validators/app-validators';
import { VisitItem } from 'src/app/core/models/visit-item';
import { MatOptionSelectionChange } from '@angular/material/core';
import { ToastMsgService } from 'src/app/core/services/toast-msg.service';
//import { ThrowStmt } from '@angular/compiler';


@Component({
  selector: 'app-find-time',
  templateUrl: './find-time.component.html',
  styleUrls: ['./find-time.component.scss']
})
export class FindTimeComponent implements OnInit, AfterViewInit {
  error: string;
  settings: Settings;
  form: UntypedFormGroup;
  results: CustomerSearchResult[];
  loading: boolean;
  message = '';
  hasPermission: boolean;
  searchText = new Subject<string>();
  patients: Observable<CustomerSearchResult[]>;
  practices: PracticeModel[] = [];
  terminology: TerminologyItem[] = [];
  branches: ComplexBranch[] = [];
  schedulers: SchedulerModel[] = [];
  rooms: SelectListItem[] = [];
  firstDayOfWeek: number = 0;
  minDuration: number = 5;
  maxDuration: number = 720; // 12 hours
  minHour: string = '00:00';
  maxHour: string = '1.00:00';
  subscription: any;
  treatments: TreatmentEntity[] = [];
  priceListCodes: PriceListCode[] = [];

  startTimeList: SelectListItem[] = [];
  endTimeList: SelectListItem[] = [];

  selectedPatientID?: number;

  isReasonRequired = true;
  isRoomRequired = false;

  private subPractice: any;
  private subBranch: any;
  private subSchedulere: any;
  private subReason: any;
  private subRoom: any;

  private days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];


  constructor(
    private appSettings: AppSettings,
    public fb: UntypedFormBuilder,
    public translate: TranslateService,
    private searchService: SearchCustomerService,
    private authService: AuthenticateService,
    private standbyService: StandbyService,
    private schedulerService: SchedulerService,
    private location: Location,
    private findTimeService: FindTimeService,
    private scopeService: ScopeService,
    private appData: AppData,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private toastMsg: ToastMsgService) {

    this.settings = appSettings.settings;
    this.hasPermission = authService.claims.CanEditConfidentialPatients || false;
    this.treatments = appData.treatments;
    this.priceListCodes = appData.priceListCodes;

  }

  ngOnInit() {

    this.isRoomRequired = this.authService.claims.RequiredRoomInAppointment;
    console.log('ngOnInit');
    this.getScopeFromSession();
    this.initForm();
    this.getBranches();
    this.getScheduler();
    this.getRooms();

  }


  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

  initForm() {
    console.log('initForm');
    
    // load previous form state or default value
    var formState = Object.assign(this.defualtFormState(), this.loadState());

    this.form = this.fb.group({
      'formStateSaved': formState.formStateSaved,
      'patient': [formState.patient as CustomerSearchResult, Validators.required],
      'practice': [formState.practice, Validators.required],
      'branch': [{ value: formState.branch, disabled: !formState.practice }],
      'scheduler': [{ value: formState.scheduler, disabled: !formState.practice }],
      'room': [{ value: formState.room, disabled: !formState.branch }],
      'roomName': [{ value: formState.roomName }],
      'reason': [formState.reason, Validators.required], // can be pricelistCodes or treatments
      'startDate': [moment(formState.startDate), Validators.required],
      'startTime': [formState.startTime, Validators.required],
      'endTime': [formState.endTime, Validators.required],
      'duration': [formState.duration, Validators.compose([Validators.required, Validators.min(this.minDuration), Validators.max(this.maxDuration)])],
      'sunday': [formState.sunday],
      'monday': [formState.monday],
      'tuesday': [formState.tuesday],
      'wednesday': [formState.wednesday],
      'thursday': [formState.thursday],
      'friday': [formState.friday],
      'saturday': [formState.saturday],
      'hasTreatmentsTodo': [formState.hasTreatmentsTodo],
    }, { validator: [timeCheckValidator('startTime', 'endTime')] });

    
    

    // subsribe to text change to search patients (use async pipe in html)
    this.patients = this.searchText.pipe(
      // only once every 500ms
      debounceTime(500),
      // ignore duplicates
      distinctUntilChanged(),
      //  send the search request to the service.
      switchMap(text => this.searchService.search(this.getFilterData(text)))
    );


    this.getSelectedVisitReasons();
    const duration = this.appData.getDuration() || 0;
    if (duration) {
      this.setDuration(duration);
    }


    if (!this.isFormStateSaved() && this.appData.appointment) {
      this.fillTreatmentsByAppointment(this.appData.appointment);
    }


    // if findtime from customer details, plant customer's details.
    if (this.appData.customerDetails) {
      // set necessary data for customer details display in create-appointment.html
      let customerDetails = this.appData.customerDetails;
      this.f.patient.setValue({
        EntityID: customerDetails.ID,
        Name: customerDetails.Name,
        Age: customerDetails.Age,
        Gender: this.translate.instant(`GENDER.${customerDetails.Gender}`),
        Phone: customerDetails.Mobile
      });
      this.checkIfHasTodoTreatments(this.appData.customerDetails.ID);

      // clear appData.customerDetails
      this.appData.customerDetails = null;

    }


    // init timePicker with min&max hours, timepicker is re-initialized after picking therapist
    this.startTimeList = Utils.generateTimeList(this.minHour, this.maxHour, 30, false);
    this.endTimeList = Utils.generateTimeList(this.minHour, this.maxHour, 30, true);
    this.selectedPatientID = this.getSelectedPatientID();


    this.onChange();
  }

  setDuration(duration: number) {
    if (duration > 0)
      this.f.duration.setValue(duration);

  }

  getSelectedPatientID(): number | null {
    const patient: unknown = this.form.controls.patient.value;
    const pat = patient as CustomerSearchResult;
    if (pat != null) {
      return +pat.EntityID; // the plus sign convert string to number
    }
    return null;
  }

  getSelectedVisitReasons(): any[] {
    console.log('getSelectedVisitReasons');
    const reasons: any[] = [];
    this.treatments = this.appData.treatments || [];
    this.priceListCodes = this.appData.priceListCodes || [];


    if (this.priceListCodes.length > 0) {
      this.priceListCodes.forEach(element => {
        reasons.push(element);
      });
    }

    if (this.treatments.length > 0) {
      this.treatments.forEach(element => {
        reasons.push(element);
      });
    }

    if (reasons && reasons.length > 0) {
      this.f.reason.setValue(reasons);

      var combinedTreatmentDuration = 0;
      reasons.forEach(element => {
        if (element.Duration) { // treatments from pricelist expose duration directly
          combinedTreatmentDuration += element.Duration;
        } else if (element.PriceListCode) { // treatments from card expose duration form within PriceListCode object.
          combinedTreatmentDuration += element.PriceListCode.Duration;
        }
      });
      this.setDuration(combinedTreatmentDuration);
    } else {
      this.f.reason.setValue(null);
    }

    return reasons;
  }


  getTreatmentSummary(treatment: TreatmentEntity) {
    return Utils.treatmentToString(treatment, this.translate);
  }

  getPriceListSummary(priceListCode: PriceListCode) {
    return Utils.priceListCodeToString(priceListCode, this.translate);
  }

  treatmentsVisitSummary() {
    console.log('treatmentsVisitSummary');
    const treatments = this.appData.treatments;
    return this.appData.treatmentsVisitSummary(treatments);
  }
  priceListCodeVisitSummary() {
    console.log('priceListCodeVisitSummary');
    const priceListCodes = this.appData.priceListCodes;
    return this.appData.priceListCodeVisitSummary(priceListCodes);
  }



  defualtFormState(): any {

    console.log('defualtFormState');
    var deafultState = {
      formStateSaved: false,
      patient: '',
      practice: null,
      branch: null,
      scheduler: null,
      room: null,
      roomName: '',
      reason: null,
      startDate: moment().startOf('day'), // set to 12:00 am today
      startTime: this.minHour,
      endTime: this.maxHour,
      duration: 30,
      sunday: true,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true
    };

    // set default user scope
    var scope = this.scopeService.userScope;
    if (scope) {

      if (scope.userHasScheduler) {
        deafultState.practice = scope.userPracticeID || null;
        deafultState.branch = scope.userDefaultBranchID || null;
        deafultState.scheduler = scope.userSchedulerID || null;
      }

      else if (this.practices && this.practices.length === 1) {
        // if only one practice exists select it
        deafultState.practice = this.practices[0].ID;
      }
    }

    return deafultState;
  }

  fillTreatmentsByAppointment(appointment: AppointmentModel) {
    console.log('fillTreatmentsByAppointment');
    // load appointmentModel 
    this.schedulerService.getEventTreatments(this.appData.appointment.EventID)
      .subscribe(
        result => {
          if (result.Code === ApiResponseCode.Success) {
            // set reason
            this.treatments = result.Data as TreatmentEntity[];
            this.appData.treatments = this.treatments;
            if (this.treatments && this.treatments.length > 0) {
              this.f.reason.setValue(this.treatments);
            }

            // set duration
            const duration = this.appData.getDuration();
            this.setDuration(duration);
          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => this.error = error
      );

    this.getDaysOfWeek(); // load daysOfWeek, fromTimeList, endTimeList

  }

  onChange() {
    console.log('onChange');
    this.subscribeChanges(); // using subscribe/unsubscribe to controll unwanted onChange triggering 
  }

  subscribeChanges() {
    console.log('subscribeChanges');
    this.subPractice = this.f.practice.valueChanges.subscribe(x => {
      console.log('practice change: ' + x);
      this.onPracticeChange(x);
    });
    this.subBranch = this.f.branch.valueChanges.subscribe(x => {
      console.log('branch change: ' + x);
      this.onBranchChange(x);
    });
    this.subSchedulere = this.f.scheduler.valueChanges.subscribe(x => {
      console.log('scheduler change: ' + x);
      this.onSchedulerChange(x);
    });
    this.subReason = this.f.reason.valueChanges.subscribe((element: VisitReason[]) => {
      if (element) {
        const duration = element.map(x => x.Duration).reduce((a, v) => a + v, 0);
        this.setDuration(duration);

      }
    });
    this.subRoom = this.f.room.valueChanges.subscribe(x => {
      this.onRoomChanged(x);
    });
  }

  unsubscribeChanges() {
    console.log('unsubscribeChanges');
    if (this.subPractice) {
      this.subPractice.unsubscribe();
    }
    if (this.subBranch) {
      this.subBranch.unsubscribe();
    }
    if (this.subSchedulere) {
      this.subSchedulere.unsubscribe();
    }
    if (this.subReason) {
      this.subReason.unsubscribe();
    }
    if (this.subRoom) {
      this.subRoom.unsubscribe();
    }
  }

  onRoomChanged(val) {
    console.log('onRoomChanged');
    if (val) {
      const roomItem = this.rooms.filter(x => parseInt(x.Value) === parseInt(val));
      if (roomItem && roomItem.length > 0) {
        this.f.roomName.setValue(roomItem[0].Text);
      }
    } else {
      this.f.roomName.setValue('');
    }
  }

  onPatientSelected(event: MatOptionSelectionChange, patient?: CustomerSearchResult) {
    console.log('onPatientSelected');
    
    // fix issue when changing patient. this function can be called twice one for the selected patient and one for the previous patient.
    if (!event.isUserInput)
      return;

    if (patient) {
      if (patient.IsBlocked) {
        this.selectedPatientID = null;        
        //clear patient
        this.form.controls['patient'].reset();
        this.toastMsg.showError(this.translate.instant('PATIENT.OPERATION-CANCELED-PATIENT-IS-BLOCKED'));
        
      }
      else {
        this.checkIfHasTodoTreatments(patient.EntityID);
        this.selectedPatientID = patient.EntityID;
      }
    }
    else {
      this.selectedPatientID = null;
    }
  }

  public onSubmit(values: any): void {

    if (this.form.valid) {
      // must select one from practice, branch or therpist/doctor
      if (!this.f.practice.value && !this.f.branch.value && !this.f.scheduler.value) {
        const term = this.translate.instant(`TERMINOLOGY.${this.terminology[1].TargetResourceKey.toUpperCase()}`);  // מטפל
        const msg = this.translate.instant('STANDBY.MUST-SELECT-ONE-OF-THE-FIELDS', { therapistTerm: term });
        alert(msg);
        return;
      }


      // Data to send to server
      const model: FindTimeModel = new FindTimeModel();
      model.FirstDayOfWeek = this.firstDayOfWeek;
      model.CustomerID = values.patient.EntityID;
      model.Date = values.startDate.toDate();
      model.ToDate = null;
      model.Duration = values.duration;
      model.ExpertiesID = values.practice;
      model.BranchID = values.branch;

      // can be one or list =>   1 or 1,2,3,4
      if (!model.BranchID) {
        model.BranchID = this.branches.map(x => x.BranchID).toString();
      }

      // can be one or list =>   1 or 1,2,3,4
      model.SchedulerIDForUser = values.scheduler;
      if (!values.scheduler) {
        model.SchedulerIDForUser = this.schedulers.map(x => x.ID).toString();
      }

      // validate scheduler
      if (!model.SchedulerIDForUser) {
        this.error = this.translate.instant('FIND-TIME.NO-SCHEDULERS');
        return;
      }

      if (!model.BranchID) {
        this.error = this.translate.instant('FIND-TIME.NO-BRANCHES');
        return;
      }


      model.SchedulerIDForRoom = values.room > 0 ? values.room : null;
      model.StartTime = values.startTime;
      model.EndTime = values.endTime;
      model.WeekDays = [
        values.sunday || false,
        values.monday || false,
        values.tuesday || false,
        values.wednesday || false,
        values.thursday || false,
        values.friday || false,
        values.saturday || false,
      ];


      model.TreatmentID = ''; // default      
      model.PriceListRefIds = values.reason ? values.reason.map(x => x.PriceListRefID).toString() : '';
      if (this.appData.treatments) {
        const treatments = this.appData.treatments;
        model.TreatmentID = treatments.map(x => x.TherapistID).toString(); // 1 or 1,2,3...
      }


      this.findTimeService.findTimeGroup(model).subscribe(result => {
        if (result.Code === ApiResponseCode.Success) {
          this.appData.findTimeGroupResult = result.Data.map(item => new FindTimeResultItem(item));
          this.showResult();
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      }, error => {
        this.error = error;
      });
    }
  }

  showResult() {
    console.log('showResult');
    this.saveFromState();
    this.router.navigate(['/find-time-group-result']);
  }

  saveFromState() {
    console.log('saveFromState');
    this.f.formStateSaved.setValue(true);
    this.appData.formStateFindTime = this.form.value;
  }

  isFormStateSaved() {
    console.log('isFormStateSaved');
    const formState = this.appData.formStateFindTime;
    return formState && formState.formStateSaved || false;
  }

  loadState(): any {
    console.log('loadState');
    // return JSON.parse(sessionStorage.getItem('find-time-state'));
    const formState = this.appData.formStateFindTime || {};
    const appointment: AppointmentModel = this.appData.appointment;
    const visit: VisitItem = this.appData.visitItem;


    // load state by appointment
    if (!this.isFormStateSaved()) {
      if (appointment) {
        const patient = new CustomerSearchResult(appointment); // fill EntityID
        patient.Name = appointment.Title;
        formState.patient = patient;
        formState.practice = appointment.PractiseID;
        formState.scheduler = appointment.SchedulerID;
        formState.branch = appointment.BranchID;

        formState.room = appointment.SchedulerRoomID > 0 ? appointment.SchedulerRoomID.toString() : '';  // needs to be string as SelecListItem.Value = string.

      } else if (visit) {

        const patient = new CustomerSearchResult();
        patient.EntityID = visit.CustomerID;
        patient.Name = visit.CustomerName;
        formState.patient = patient;
        formState.practice = visit.TherapistPracticeID;
        formState.scheduler = visit.SchedulerID;
        formState.branch = visit.BranchID;

      }
    }

    return formState;

  }

  clearState() {
    console.log('clearState');
    // sessionStorage.removeItem('find-time-state');
    this.appData.formStateFindTime = null;
  }

  onCancel(event) {
    console.log('onCancel');
    let navigateTo = this.appData.findTimeCancelButtonRoute || '/scheduler';  // get the origin route from where the initial find time was called.
    this.router.navigate([navigateTo]);
  }

  onDurationChanged() {
    console.log('onDurationChanged');
    let duration = this.f.duration.value;
    if (duration % 5 !== 0) {
      this.setDuration(duration - (duration % 5));
    }
  }

  onSchedulerChange(val) {
    console.log('onSchedulerChange');
    this.getDaysOfWeek();

    const patient = this.f.patient.value;
    const customerID = parseInt(patient && patient.EntityID || '0');
    this.getDefaultTreatment(val, customerID);
    this.toggleReasonRequiredValidator();
    this.toggleRoomRequiredValidator();
  }

  getDefaultTreatment(schedulerID?: number, customerID?: number) {
    console.log('getDefaultTreatment');
    if (schedulerID == undefined || schedulerID == null || schedulerID == 0) {
      return;
    }
    if (customerID == 0) {
      return;
    }

    this.findTimeService.getDefaultTreatment(schedulerID, customerID).subscribe(result => {

      if (result.Code == ApiResponseCode.Success) {
        if (result.Data) {
          const model = new PriceListCode(result.Data);
          const treatments = this.appData.treatments || [];
          const pricelistCodes = this.appData.priceListCodes || [];
          // select the default treatmet only for new form
          if (pricelistCodes.length === 0 && treatments.length === 0) {
            pricelistCodes.push(model);
            this.appData.priceListCodes = pricelistCodes;
          }
          this.getSelectedVisitReasons();
        }

      }
      else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    },
      error => {
        this.error = error;
      });

  }

  onPracticeChange(practiceID) {
    console.log('onPracticeChange');
    this.unsubscribeChanges();

    // clear and realod braches, schedulers, room
    const branchID = this.f.branch.value || 0;
    practiceID = practiceID ? (this.f.practice.value || 0) : 0;

    this.getBranches(practiceID);
    this.getScheduler(practiceID, branchID);

    // reset values
    this.f.branch.setValue(null);
    this.setSchedulerValue(null, false, true);
    this.f.room.setValue(null);
    this.f.reason.setValue(null);

    if (practiceID > 0) {
      this.f.branch.enable();
      this.f.scheduler.enable();

    } else {
      this.f.branch.disable();
      this.f.scheduler.disable();
    }

    this.subscribeChanges();
  }

  onBranchChange(val) {
    console.log('onBranchChange');
    this.unsubscribeChanges();

    this.getScheduler(null, null, true);
    this.getRooms(true)


    this.subscribeChanges();
  }

  clearBranch(e) {

    this.form.controls.branch.setValue(undefined);
  }

  getDaysOfWeek() {
    debugger;
    console.log('getDaysOfWeek');
    const args = this.getArguments();
    this.findTimeService.getDaysOfWeek(args)
      .pipe(
        debounceTime(500), // only once every 500ms
        distinctUntilChanged(), // ignore duplicates
        last()         // only last items
      )
      .subscribe(
        result => {
          if (result.Code === ApiResponseCode.Success) {

            const data = result.Data; // daysOfWeek: boolean[7], min: time, max: time  
            this.refreshDaysOfWeek(data.daysOfWeek);

            this.minHour = data.min.substring(0, data.min.length - 3);
            this.maxHour = data.max.substring(0, data.max.length - 3)
            this.f.startTime.setValue(this.minHour);
            this.f.endTime.setValue(this.maxHour);
            this.startTimeList = Utils.generateTimeList(data.min, data.max, 30, false);
            this.endTimeList = Utils.generateTimeList(data.min, data.max, 30, true);
          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => {
          this.error = error;
        });
  }

  refreshDaysOfWeek(daysOfWeek: boolean[]) {
    console.log('refreshDaysOfWeek');
    // disable/ enable the week days
    for (let index = 0; index < daysOfWeek.length; index++) {
      const checked = daysOfWeek[index];
      const control = this.form.get(this.days[index]);
      control.setValue(daysOfWeek[index]);
      checked ? control.enable() : control.disable();
    }
  }

  getRooms(unsubscribeBeforeChange?: boolean) {
    console.log('getRooms');
    const practiceID = this.f.practice.value || 0;
    const branchID = this.f.branch.value || 0;
    const scheduler = this.f.scheduler.value || null;
    const fromTime = this.f.startTime.value || null;
    const toTime = this.f.endTime.value || null;
    const sunday = this.f.sunday.value || false;
    const monday = this.f.monday.value || false;
    const tuesday = this.f.tuesday.value || false;
    const wednesday = this.f.wednesday.value || false;
    const thursday = this.f.thursday.value || false;
    const friday = this.f.friday.value || false;
    const saturday = this.f.saturday.value || false;

    const roomID = this.f.room.value || 0;


    this.standbyService.getRooms(practiceID, branchID, scheduler, fromTime, toTime, sunday, monday, tuesday, wednesday, thursday, friday, saturday)
      .subscribe(result => {
        if (result.Code === ApiResponseCode.Success) {
          this.rooms = result.Data as SelectListItem[];
          const count = this.rooms && this.rooms.length || 0;
         
          // clear current roomID if not in the new rooms list
          if (this.rooms.filter(x => parseInt(x.Value) === parseInt(roomID)).length === 0) {
            this.setRoomValue('', true, unsubscribeBeforeChange);
          }
         


        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
        error => {
          this.error = error;
        });
  }


  /** load scheduler, practices, firstDay of week */
  getScopeFromSession() {
    console.log('getScopeFromSession');

    var scope = this.scopeService.userScope;
    if (scope) {
      // this.schedulers = scope.schedulers;      
      this.practices = scope.practices;
      this.firstDayOfWeek = scope.firstDayOfWeek;
      this.terminology = scope.terminology;

      this.minHour = scope.minTime.substring(0, scope.minTime.length - 3); // 08:00:00 => 08:00 we must send without the seconds
      this.maxHour = scope.maxTime.substring(0, scope.maxTime.length - 3); // 18:00:00 => 18:00
    }
  }

  /** create object to filter  */
  getFilterData(text): SearchCustomerFilter {
    console.log('getFilterData');
    return {
      FilterText: text,
      FilterPatients: true,
      FilterSuppliers: false,
      FilterPhoneBook: false,
      FilterActive: true,
      FilterInactive: false
    };
  }



  getBranches(practiceID?: number) {
    console.log('getBranches');
    practiceID = practiceID ? practiceID : (this.f.practice.value || 0);

    this.standbyService.getBranches(practiceID).subscribe(result => {
      if (result.Code === 1) {
        // success
        this.branches = result.Data as ComplexBranch[];

        if (this.branches && this.branches.length === 1) {
          let firstBranch = this.branches[0];
          if (this.f.branch.value != firstBranch.BranchID) {
            this.f.branch.setValue(firstBranch.BranchID);
            this.f.branch.markAsTouched();
          }
        }

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    },
      error => {
        this.error = error;
      });
  }

  getScheduler(practiceID?: number, branchID?: number, unsubscribeBeforeChange?: boolean) {
    console.log('getScheduler');
    practiceID = practiceID ? practiceID : (this.f.practice.value || 0);
    branchID = branchID ? branchID : (this.f.branch.value || 0);
    const schedulerID = this.f.scheduler.value || 0;

    this.standbyService.getSchedulers(practiceID, branchID)
      .subscribe(
        result => {
          if (result.Code === ApiResponseCode.Success) {
            this.schedulers = result.Data.map(item => new SchedulerModel(item));
            this.appData.Schedulers = this.schedulers;
            const count = this.schedulers && this.schedulers.length || 0;

            // only one scheduler exists
            if (count === 1) {
              let firstScheduler = this.schedulers[0];
              if (schedulerID != firstScheduler.ID) {
                this.setSchedulerValue(firstScheduler, true, unsubscribeBeforeChange);
              }
            }
            // multiple schedulers
            else {
              // clear previous scheduler if not in the new result
              if (schedulerID > 0 && this.schedulers.filter(s => s.ID === schedulerID).length === 0) {
                this.setSchedulerValue(null, true, unsubscribeBeforeChange);
              }
            }

            // after schedulers loaded and scheduler ID is set toggle the required mark for treatmets
            this.toggleReasonRequiredValidator();
            this.toggleRoomRequiredValidator();

          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => this.error = error
      );
  }


  search(event, autocompleteEl) {

    const name = autocompleteEl._element.nativeElement.value;
    //this.searchText.next(name);

    if (event.key !== 'Enter' &&
      event.key !== 'Tab' &&
      event.key !== ' ' &&
      event.key !== 'Escape') {
      this.searchService.search(this.getFilterData(name)).subscribe(result => {
        this.patients = of(result);
        autocompleteEl.openPanel();
      });
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
    }



  }


  // search(name: string) {         
  //   console.log('search');
  //   this.searchText.next(name);
  // }

  searchOnEnter(event, autocompleteEl) {

    event.preventDefault();
    event.stopPropagation();
    //autocompleteEl.openPanel();
    const text = autocompleteEl._element.nativeElement.value;
    this.searchService.search(this.getFilterData(text)).subscribe(result => {
      this.patients = of(result);
      autocompleteEl.openPanel();
    });
  }




  searchButtonClicked(event, autocompleteEl) {

    // open panel on click - for browsers that not find 
    event.preventDefault();
    event.stopPropagation();
    //autocompleteEl.openPanel();
    const text = autocompleteEl._element.nativeElement.value;
    this.searchService.search(this.getFilterData(text)).subscribe(result => {
      this.patients = of(result);
      autocompleteEl.openPanel();
    });


  }


  displayFn(patient?: CustomerSearchResult): string | undefined {
    return patient ? patient.Name : undefined;
  }



  canWatchConfidential(item: CustomerSearchResult) {
    console.log('canWatchConfidential');
    if (this.hasPermission) {
      return true;
    } else {
      return !item.IsConfidential;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  // for debug only
  get diagnostic() { return JSON.stringify(this.form.value); }

  onSelectVisitReason(feature) {
    console.log('onSelectVisitReason');
    this.saveFromState();

    // pass form data to select a treatment
    this.appData.arguments = this.getArguments();

    // navigate to 'select-from-pricelist' or 'select-from-card'
    this.router.navigate([feature]);
  }

  onSelectVisitReasonFromChild(data) {
    this.saveFromState();
    this.appData.arguments = data.args;
    // navigate to 'select-from-pricelist' or 'select-from-card'
    this.router.navigate([data.feature]);

  }


  getArguments(): Arguments {
    console.log('getArguments');
    const values = this.form.value;
    const args = new Arguments();
    args.CustomerID = values.patient && values.patient.EntityID || 0;
    args.PracticeID = values.practice || 0;
    args.Branches = values.branch;

    // can be one or list =>   1 or 1,2,3,4
    args.Branches = values.branch ? values.branch : this.branches.map(x => x.BranchID).toString();

    // can be one or list =>   1 or 1,2,3,4
    args.Schedulers = values.scheduler ? values.scheduler : this.schedulers.map(x => x.ID).toString();
    return args;
  }

  onClearVisitReason() {
    console.log('onClearVisitReason');
    this.clearVisitReason();
  }

  onClearVisitReasonFromChild(data) {
    console.log('onClearVisitReasonFromChild');
    this.clearVisitReason();
    this.cdr.detectChanges(); // fix issue that child component not re-rendered
    this.cdr.markForCheck();
  }

  clearVisitReason() {
    this.form.get('reason').setValue(null);
    this.setDuration(this.minDuration);
    this.appData.treatments = this.treatments = null;
    this.appData.priceListCodes = this.priceListCodes = null;
    this.toggleReasonRequiredValidator();
  }

  onClearTreatment(event: any, treatment: TreatmentEntity) {
    console.log('onClearTreatment');
    this.appData.removeFromTreatments(treatment.ID);
    this.getSelectedVisitReasons();
    this.toggleReasonRequiredValidator();
  }

  onClearTreatmentFromChild(treatment: TreatmentEntity) {
    console.log('onClearTreatment');
    this.appData.removeFromTreatments(treatment.ID);
    this.getSelectedVisitReasons();
    this.toggleReasonRequiredValidator();
  }

  onClearPriceListCode(event: any, priceListCode: PriceListCode) {
    console.log('onClearPriceListCode');
    this.appData.removeFromPriceListCodes(priceListCode.PriceListRefID);
    this.getSelectedVisitReasons();
    this.toggleReasonRequiredValidator();
  }

  onClearPriceListCodeFromChild(priceListCode: PriceListCode) {
    console.log('onClearPriceListCode');
    this.appData.removeFromPriceListCodes(priceListCode.PriceListRefID);
    this.getSelectedVisitReasons();
    this.toggleReasonRequiredValidator();
  }

  onClearPatient(event) {
    console.log('onClearPatient');
    this.f.patient.setValue(undefined);
    this.onClearVisitReason();
    this.f.hasTreatmentsTodo.setValue(false);
    this.selectedPatientID = null;
  }

  checkIfHasTodoTreatments(customerID?: number) {
    console.log('checkIfHasTodoTreatments: ' + customerID);
    this.f.hasTreatmentsTodo.setValue(false);
    if (!customerID) {
      return;
    }

    this.findTimeService.hasTreatmentsTodo(customerID)
      .subscribe(
        result => {
          if (result.Code === ApiResponseCode.Success) {
            this.f.hasTreatmentsTodo.setValue(result.Data.hasToDoTreatment);
          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => {
          this.error = error;
        }
      );
  }



  toggleReasonRequiredValidator(): void {
    // allow to create appointment without treatmens when scheduler.NoMandatoryVisitReason=TRUE
    const control = this.form.get('reason');
    const schedulerID = this.f.scheduler.value;
    const scheduler = this.schedulers.find(x => x.ID == schedulerID);
    this.isReasonRequired = !(scheduler?.NoMandatoryVisitReason ?? true);

    if (control) {
      if (!this.isReasonRequired) {
        // make the field not required
        const currentValidators = control.validator ? [control.validator] : [];
        const updatedValidators = currentValidators.filter(validatorFn => validatorFn !== Validators.required);
        control.setValidators(null);
        control.updateValueAndValidity();
        //control.markAsTouched();
        //this.cdr.markForCheck();

        // set default duration if no treatments selected
        const treatments = this.appData.treatments || [];
        const priceListCodes = this.appData.priceListCodes || [];
        const hasVisitReason = treatments.length + priceListCodes.length > 0;
        if (!hasVisitReason) {
          this.setDuration(scheduler.DefaultDuration ?? 30);
        }
      }
      else {
        // make the field required
        control.addValidators(Validators.required);
        control.updateValueAndValidity();
        //control.markAsTouched();
        //this.cdr.markForCheck();
      }

    }
  }

  setSchedulerValue(scheduler: SchedulerModel | null = null, markedAsTouched: boolean, unsubscribeBeforeChange: boolean) {
    console.log('setSchedulerValue: ' + scheduler);
    if (unsubscribeBeforeChange === true) {
      this.unsubscribeChanges();
    }
    const value = scheduler?.ID ?? null;
    if(this.f.scheduler.value != value){
      this.f.scheduler.setValue(value);
    }

    if (markedAsTouched) {
      this.f.scheduler.markAsTouched();
    }

    if (unsubscribeBeforeChange === true) {
      this.subscribeChanges();
    }
  }



  setRoomValue(value: string, markedAsTouched: boolean, unsubscribeBeforeChange: boolean) {
    console.log('setRoomValue: ' + value);
    if (unsubscribeBeforeChange === true) {
      this.unsubscribeChanges();
    }

    this.f.room.setValue(value); // to string
    this.onRoomChanged(value); // set room name

    var branchID = this.f.branch.value;
    if (branchID > 0) {
      this.f.room.enable();
    } else {
      this.f.room.disable();
    }

    if (markedAsTouched) {
      this.f.room.markAsTouched();
    }

    if (unsubscribeBeforeChange === true) {
      this.subscribeChanges();
    }
  }

  toggleRoomRequiredValidator(){
    
    if(this.schedulers == null)
      return;

    const schedulerID = this.f.scheduler.value;
    const scheduler = this.schedulers.find(x => x.ID == schedulerID);
    this.isRoomRequired = scheduler?.IsRoomRequired ?? false;
    const control = this.form.get('room');
    //const roomID = this.f.room.value;
    if (control) {
      if(this.isRoomRequired){        
        control.addValidators(Validators.required);
        //control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      }else{
        const currentValidators = control.validator ? [control.validator] : [];
        const updatedValidators = currentValidators.filter(validatorFn => validatorFn !== Validators.required);
        control.setValidators(null);
        control.updateValueAndValidity();
      }
    }
  }

}
